import axios from "axios";
import { API_BASE } from "@/config/site";

export const api = axios.create({ baseURL: API_BASE, timeout: 20000 });

const TOKEN_KEY = "uhlumo_admin_token";
export const getToken = () => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (!t) return null;
  try {
    const { exp } = JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (exp && exp * 1000 < Date.now()) {
      localStorage.removeItem(TOKEN_KEY);
      return null;
    }
  } catch {
    return null;
  }
  return t;
};
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const adminApi = axios.create({ baseURL: `${API_BASE}/admin`, timeout: 20000 });
adminApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !String(err?.config?.url || "").includes("/login")) {
      setToken(null);
      if (!window.location.pathname.startsWith("/admin/login")) window.location.assign("/admin/login");
    }
    return Promise.reject(err);
  }
);

export function errorMessage(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message === "Network Error" ? "Network error. Please check your connection and try again." : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d
      .map((e) => {
        const field = Array.isArray(e.loc) ? e.loc[e.loc.length - 1] : "";
        const msg = String(e.msg || "").replace(/^Value error, /, "");
        return field && !msg.toLowerCase().includes(String(field)) ? `${String(field).replace(/_/g, " ")}: ${msg}` : msg;
      })
      .join(" ");
  }
  return fallback;
}
